module.exports = __webpack_public_path__ + "static/media/mechanical.b5b374a5.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/mechanical.svg
// module id = 137
// module chunks = 0